import type { LiquidityPoolMap } from "@stepfinance/liquidity";

import type { MercurialReward } from "../../hooks";

export type MercurialRewardsByPool = {
  [poolAddress: string]: MercurialRewardBySymbol;
};

type MercurialRewardBySymbol = {
  [symbol: string]: {
    total: number;
    ids: string[];
  };
};

export const parseMercurialRewards = (mercurialPools: LiquidityPoolMap<"Mercurial">, rewards: MercurialReward[]) => {
  const mercurialPoolsByAccountAddress = new Map(
    Object.values(mercurialPools).map((pool) => [pool.accountAddress, pool]),
  );
  const rewardsByPool: MercurialRewardsByPool = {};
  for (const node of rewards) {
    const { name, pool, id } = node;
    const poolAddress = mercurialPoolsByAccountAddress.get(pool)?.accountAddress;
    if (!poolAddress) {
      console.error("Unknown mercurial pool code");
      continue;
    }

    const [amount, rewardSymbol] = parseRewardAmount(name);
    if (rewardsByPool[poolAddress]) {
      if (rewardsByPool[poolAddress][rewardSymbol]) {
        rewardsByPool[poolAddress][rewardSymbol].total += amount;
        rewardsByPool[poolAddress][rewardSymbol].ids.push(id);
      } else {
        rewardsByPool[poolAddress][rewardSymbol] = {
          total: amount,
          ids: [id],
        };
      }
    } else {
      rewardsByPool[poolAddress] = {
        [rewardSymbol]: {
          total: amount,
          ids: [id],
        },
      };
    }
  }
  return rewardsByPool;
};

type RewardAmount = [amount: number, name: string];
const parseRewardAmount = (rewardName: string): RewardAmount => {
  const [amount, name] = rewardName.split(" ");
  return [parseFloat(amount), name];
};
